<template>
  <div class="wrapper">
    <div class="head">
      <div class="head-content">
        <div class="head-image">
          <img src="@assets/img/user-pic.png" alt="">
        </div>
        <div class="head-companyName">
          <p class="head-companyTitle" v-if="userInfo.registerFrom === '11'"><WorkWechatAuth openType="userName" :openId="userInfo.unionId"/></p>
          <p class="head-companyTitle" v-else>{{userInfo.trueName}}</p>
          <p class="head-companyTel" @click="gotoPage('/user-center/user-info')" v-if="!isThirdSystem()">{{userInfo.phone}} <span class="iconfont">&#xe6b3;</span></p>
        </div>
        <img class="head-bg" src="@assets/img/user-center-banner-bg.png"/>
      </div>
    </div>
    <div class="company-wrap">
      <ChangeCompany/>
    </div>
    <div class="personal-info">
      <div class="item" @click="gotoPage('/eTaxLogin/index')">
        <div class="title">
          <i class="allIconFont face-recognition">&#xe611;</i>
          <span>登录电子税局</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/faceRecognition/index')">
        <div class="title">
          <i class="allIconFont face-recognition">&#xe6dd;</i>
          <span>人脸认证</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/user-center/information')" v-if="isH5Plus()">
        <div class="title">
          <i class="iconfont">&#xe669;</i>
          <span>信息管理</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/user-center/company-info')">
        <div class="title">
          <i class="iconfont">&#xe6ce;</i>
          <span>我的企业</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/user-center/staff-list')">
        <div class="title">
          <i class="iconfont">&#xe6d7;</i>
          <span>我的员工</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/customer/list')">
        <div class="title">
          <i class="iconfont">&#xe6cd;</i>
          <span>我的客户</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/user-center/goodsList')" v-if="isH5Plus()">
        <div class="title">
          <i class="iconfont">&#xe66a;</i>
          <span>商品管理</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="gotoPage('/user-center/reset-password')" v-if="!isThirdSystem()">
        <div class="title">
          <i class="iconfont">&#xe6dd;</i>
          <span>修改密码</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
      <div class="item" @click="logOut" v-if="!isThirdSystem()">
        <div class="title">
          <i class="iconfont">&#xe6bf;</i>
          <span>退出</span>
          <i class="iconfont right-icon">&#xe648;</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localStorage, isH5Plus } from '@utils/basicUtil'
import ChangeCompany from '@components/ChangeCompany'
import WorkWechatAuth from '@components/WorkWechatAuth'
import { wxAuth } from '@utils/plugin'

export default {
  data () {
    return {
      phone: '',
      trueName: '',
      mainAccountId: '',
      productType: '',
      defaultCompany: '',
      defaultCompanyId: '',
      innerFlag: 1
    }
  },
  computed: {
    companyInfo () {
      return this.$store.state.user.company
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  mounted () {
    wxAuth()
  },
  methods: {
    lookCompanyInfo () {
      this.$router.push(`/user-center/company-info`)
    },
    gotoPage (url) {
      this.$router.push(url)
    },
    async logOut () {
      if (localStorage.get('X-C-Token')) {
        localStorage.delete('X-C-Token')
      }
      localStorage.delete('X-Access-Token')
      window.location.href = '/user/login'
    },
    isThirdSystem () {
      if (this.userInfo.registerFrom === '9' || this.userInfo.registerFrom === '10' || this.userInfo.registerFrom === '11') { // 钉钉或飞书
        return true
      }
      return false
    },
    isH5Plus () {
      return isH5Plus()
    }
  },
  components: {
    ChangeCompany,
    WorkWechatAuth
  }
}
</script>

<style lang="less" scoped>
  .wrapper {
    width: 100%;
    min-height: 100%;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    header {
      height: 96px;
      width: 100%;
      text-align: center;
      line-height: 96px;
      font-size: 32px;
      font-weight: bold;
      background: white;
    }
  }
  .face-recognition{
    color: #2372FF;
    font-weight: 600;
  }
  .head {
    box-sizing: border-box;
    width: 100%;
    height: 227px;
    padding: 0 30px;
    display: flex;
    // justify-content: center;
    align-items: center;
    background-color: #fff;
    background-size: cover;
    background: linear-gradient(89deg, #7E83FF 0%, #2372FF 100%);
    .head-content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      .head-image {
        img  {
          width: 104px;
          height: 104px;
        }
      }
      .head-companyName {
        font-family: 'PingFang SC';
        font-size: 32px;
        font-weight: 400;
        color: #fff;
        margin-left: 30px;
        .head-companyTitle{
          font-size: 34px;
          font-weight: bold;
        }
        .head-companyTel{
          font-size: 30px;
          font-weight: 500;
          margin-top: 10px;
          span.iconfont{
            font-size: 26px;
            margin-left: 18px;
          }
        }
      }
      .head-bg{
        width: 195px;
        height: 165px;
        align-self: flex-end;
        margin-left: auto
      }
    }
  }
  .company-wrap{
    margin-top: 20px;
    height: 120px;
  }
  .personal-info {
    margin-top: 20px;
    overflow: scroll;
    background: #fff;
    flex-grow: 1;
    overflow: hidden;
    .item {
      width: 100%;
      height: 100px;
      line-height: 100px;
      font-size: 30px;
      font-weight:500;
      color:rgba(51,51,51,1);
      // border-bottom: 0.5px solid #eee;
      background: #fff;
      padding: 0 30px;
      box-sizing: border-box;
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        span {
          font-size: 32px;
          margin-left: 65px;
          color: #333;
          display: inline-block;
          width: 40%;
        }
        .account-phone {
          margin-left: 0;
          width: calc(60% - 140px);
          text-align: right;
          color: #666;
        }
        i {
          font-size: 40px;
          color: #4573DE;
        }
        .right-icon {
          font-size: 30px;
          color: #999;
          display: inline-block;
          flex-grow: 1;
          text-align: right;
        }
      }
    }
  }
</style>
